import { render, staticRenderFns } from "./allFund.vue?vue&type=template&id=45cedc5b&scoped=true"
import script from "./allFund.vue?vue&type=script&lang=js"
export * from "./allFund.vue?vue&type=script&lang=js"
import style0 from "./allFund.vue?vue&type=style&index=0&id=45cedc5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cedc5b",
  null
  
)

export default component.exports